export const tooltipDelaySlow = 1000;
export const tooltipDelayMid = 500;
export const tooltipDelayFast = 300;

export const queryRefetchInterval = 60000; // 60 seconds
export const queryRefetchIntervalSlow = 120000; // 120 seconds

export const sessionKeys = {
  cuesheetMode: 'cuesheet-mode',
  editorMode: 'editor-mode',
};

export enum AppMode {
  Run = 'run',
  Edit = 'edit',
}
